import React, { useContext, useEffect, useState } from 'react'
import HistoricoTable from '../styles/TableHistorico'
import { Box, Divider, Grid, Icon } from '@mui/material'
import TableHeader from '../../../components/shared/tables/TableHeader'
import DefaultPainel from '../../../components/shared/Painel'
import AdaptativeGridContainer from '../../../components/shared/AdaptativeGridContainer'
import gerarPaginacao from '../../../services/pagination'
import EmprestimosHistoricos from '../../../services/http/emprestimos-historicos'
import Dater from '../../../services/DateFormat'
import getUser from '../../../services/http/user/getUser'
import BaseTooltip from '../../../components/BaseTooltip'
import Leitores from '../../../services/http/leitores/Leitores'
import BaseFilter from '../../../components/BaseFilter'
import filter from './filters'
import userToReader from './filters/functions/userToReader'
import { Obras } from '../../../services/http'
import BaseAutoComplete from '../../../components/shared/BaseAutoComplete'
import BaseDatePicker from '../../../components/shared/BaseDatePicker'
import MobileFilterHeaderContainer from '../../../components/filters/MobileFilterHeaderContainer'
import HelpIcon from '@mui/icons-material/Help'
import { PermissionsContext } from '../../../providers/permissions'

const HistoricoEmprestimos = () => {
  const { hasThisPermission } = useContext(PermissionsContext)
  const [tLoading, setTloading] = useState(false)
  const [lastPage, setLastPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(0)
  const [rows, setRows] = useState([])

  const [query, setQuery] = useState({})
  const [currentUser, setCurrentUser] = useState(null)

  const [obras, setObras] = useState([])

  const [dataDev, setDataDev] = useState(null)
  const minDate = parseInt(Dater().formatar(new Date(), 'yyyy')) - 1 + '-01-01'
  const maxDate = parseInt(Dater().formatar(new Date(), 'yyyy')) + '-12-31'

  const getHistorico = async (filters, page = 1) => {
    setTloading(true)
    const { data } = await EmprestimosHistoricos().show({
      includes: [
        'leitor',
        'exemplar.obra',
        'leitor.user',
        'leitor.biblioteca',
        'statusEmprestimo'
      ],
      ...filters,
      'orderBy[desc]': 'created_at',
      page
    })

    const aux = data.data.map((item, index) => ({
      ...item,
      id: index,
      livro: item.exemplar.obra.titulo,
      leitor: item.leitor.user.name,
      biblioteca: item.leitor.biblioteca.apelido,
      data_emp: Dater().formatar(item.created_at, 'dd/mm/yyyy hours:mins'),
      status: item.status_emprestimo.descricao
    }))

    setCurrentPage(data.current_page)
    setLastPage(data.last_page)
    setRows(aux)
    setTloading(false)
  }

  const init = async () => {
    const user = await getUser()
    setCurrentUser(user)
    if (
      hasThisPermission({ roles: 'gestor' }) ||
      hasThisPermission({ roles: 'admin' })
    ) {
      getHistorico()
      getObras()
      return
    }

    const { data } = await Leitores().show({ 'includes[user][cpf]': user.cpf })
    const leitor = data.data[0]

    setQuery(
      Object.assign(query, {
        'includes[leitor][biblioteca_id]': leitor.biblioteca_id
      })
    )

    if (leitor) {
      getHistorico({ 'includes[leitor][biblioteca_id]': leitor.biblioteca_id })
      getObras({ 'includes[exemplares][biblioteca_id]': leitor.biblioteca_id })
    }
  }

  async function getObras(filter = {}) {
    const { data } = await Obras().show({
      per_page: -1,
      ...filter
    })
    setObras(data.data)
  }

  useEffect(() => {
    init()
  }, [])

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      align: 'center',
      flex: 1
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      align: 'center',
      flex: 2.5
    },
    {
      field: 'livro',
      headerName: 'Livro',
      align: 'center',
      flex: 3
    },
    {
      field: 'status',
      headerName: 'Status',
      align: 'center',
      flex: 0.9
    },
    {
      field: 'data_emp',
      headerName: (
        <div className="d-flex align-center">
          Atualização de status
          <BaseTooltip
            title="hora referente ao horário de Brasília"
            followCursor
          >
            <HelpIcon />
          </BaseTooltip>
        </div>
      ),

      align: 'center',
      flex: 1.5
    }
  ].map(column => ({
    ...column,
    headerClassName: 'styledHeader',
    sortable: false
  }))

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => {
      getHistorico(query, value)
    }
  )
  const dataDevChange = data => {
    setQuery(
      Object.assign(query, {
        created_at: `${Dater().formatar(
          data,
          'yyyy-mm-ddT00:00:00.000000Z'
        )},${Dater().formatar(data, 'yyyy-mm-ddT23:59:49.000000Z')}`
      })
    )

    getHistorico(query)
  }

  const filtroBiblioteca = {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'includes[leitor][biblioteca_id]'
  }

  const filtrosGestor =
    hasThisPermission({ roles: 'gestor' }) ||
    hasThisPermission({ roles: 'admin' })
      ? [filtroBiblioteca]
      : []

  return (
    <Box>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer rowSpacing={0}>
          <>
            <TableHeader
              titulo="Históricos de empréstimos e devoluções"
              controls={
                <MobileFilterHeaderContainer>
                  <BaseFilter
                    color="white"
                    filter={[...filter, ...filtrosGestor]}
                    onChange={value => {
                      const array = Object.keys(value)
                      const chave = array.find(element => element === 'user_id')
                      if (chave) {
                        setQuery(
                          Object.assign(query, userToReader(value, currentUser))
                        )
                      } else {
                        setQuery(Object.assign(query, value))
                      }
                      getHistorico(query)
                    }}
                    components={
                      <>
                        <BaseAutoComplete
                          list={obras}
                          listLabel="titulo"
                          inputProps={{ label: 'Livro' }}
                          onChange={value => {
                            setQuery(
                              Object.assign(query, {
                                'includes[exemplar][obra_id]': value.id
                              })
                            )
                            getHistorico(query)
                          }}
                          sx={{ marginBottom: '1rem' }}
                        />
                        <BaseDatePicker
                          minDate={minDate}
                          maxDate={maxDate}
                          value={dataDev}
                          onChange={date => {
                            setDataDev(date)
                            dataDevChange(date)
                          }}
                          label="Data"
                          inputFormat="DD/MM/YYYY"
                          openTo="year"
                          views={['year', 'month', 'day']}
                          onClear={() => {
                            delete query.created_at
                            getHistorico(query)
                            setDataDev(null)
                          }}
                          clearable={true}
                        />
                      </>
                    }
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <HistoricoTable
                loading={tLoading}
                rows={rows}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default HistoricoEmprestimos
